import styled from "styled-components";
import { CgAttachment } from "react-icons/cg";

const Container = styled.div`
    cursor: pointer;

    .send {
        cursor: pointer;
        border-radius: 50%;
        padding: 10px;
        background-color: var(--color-main);
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;

        &:disabled {
            cursor: initial;
            background-color: ${({ theme }) => theme.secondaryBgColor};
        }

        svg {
            width: 20px;
            height: 20px;
            color: #fff;
            cursor: pointer;
        }
    }

    input {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0;
        cursor: pointer;

    }
`;

const MessageFileInput = ({setSelectedFile}) => {

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file)
        }
    };

    return (
        <Container>
            <div className="send"> 
                <CgAttachment />

                <input type="file" onChange={handleFileChange} />
            </div>
        </Container>
    );
};

export default MessageFileInput;
